var _rect, _rect2, _rect3, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVoice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#fff",
    rx: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 4,
    x: 26,
    y: 15,
    fill: "#FFD8D2",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 4,
    x: 14,
    y: 29,
    fill: "#FFD8D2",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD8D2",
    d: "M32 12.868a1 1 0 0 1 1.555-.832l6.197 4.132a1 1 0 0 1 0 1.664l-6.197 4.131A1 1 0 0 1 32 21.131v-8.263zM16 35.132a1 1 0 0 1-1.555.832l-6.197-4.132a1 1 0 0 1 0-1.664l6.197-4.131a1 1 0 0 1 1.555.832v8.263z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F08777",
    fillRule: "evenodd",
    d: "M37.154 29.277c-.746-.597-1.544-1.133-2.33-1.68-1.566-1.093-2.998-1.178-4.167.58-.656.987-1.575 1.03-2.535.598-2.648-1.194-4.693-3.032-5.891-5.707-.53-1.183-.523-2.244.717-3.08.656-.443 1.317-.967 1.265-1.934-.07-1.261-3.15-5.475-4.367-5.92-.504-.184-1.005-.172-1.518-.001-2.853.953-4.035 3.285-2.903 6.046 3.377 8.236 9.319 13.97 17.498 17.47.466.2.984.28 1.247.35 1.862.02 4.043-1.763 4.673-3.533.607-1.702-.675-2.378-1.689-3.189z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoice);
export default __webpack_public_path__ + "static/media/voice.5f8ebb7392ca7a60a526e4677edc7f5e.svg";
export { ForwardRef as ReactComponent };